import { Link, useLocation } from "wouter";
import { FileText, House, LayoutGrid, Info, SquarePen } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface Tab {
  label: string;
  href: string;
  icon: LucideIcon;
  soon?: boolean;
}

const TABS: Tab[] = [
  { label: "1. Input Data", href: "/assessment", icon: House },
  { label: "2. Results Overview", href: "/assessment/results", icon: LayoutGrid },
  { label: "3. Detailed Results", href: "/assessment/detailed", icon: SquarePen },
  { label: "4. Disclosure & Export", href: "/assessment/disclosure", icon: FileText },
  { label: "Methodology", href: "/assessment/methodology", icon: Info },
];

/**
 * Bleeds to the content edges so the strip sits flush under the TopBar, the
 * way the redesign has it — the page's own padding resumes below.
 */
export function AssessmentTabs() {
  const [location] = useLocation();

  return (
    <div className="-mx-6 -mt-6 flex gap-7 overflow-x-auto border-b border-border bg-card px-6 md:-mx-8 md:-mt-8 md:px-8">
      {TABS.map((tab) => {
        const isActive = location === tab.href;
        const content = (
          <>
            <tab.icon className="h-3.5 w-3.5 shrink-0" />
            {tab.label}
          </>
        );

        if (tab.soon) {
          return (
            <span
              key={tab.href}
              title="Coming soon"
              className="flex cursor-not-allowed items-center gap-1.5 whitespace-nowrap border-b-2 border-transparent py-3 text-sm text-muted-foreground opacity-50"
            >
              {content}
            </span>
          );
        }

        return (
          <Link key={tab.href} href={tab.href}>
            <span
              className={cn(
                "flex cursor-pointer items-center gap-1.5 whitespace-nowrap border-b-2 py-3 text-sm transition-colors",
                isActive
                  ? "border-primary font-bold text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              )}
            >
              {content}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
